import { ObjectFieldDataType, ObjectTable, ObjectFieldSetting ,ObjectFieldLabel} from "../models";

export class ObjectField {
    Id: number | null;
    Tenant: number;
    ObjectTableCode: string;
    Name: string;
    Code: string;
    objectFieldDataType:ObjectFieldDataType
    DataTypeCode: string;
    IsCustom: boolean;
    CustomPickListId: number;
    LookupObjectTableCode: string;
    CanFilter: boolean;
    SortBy: string | null;
    WidthStyle: string | null;
    ShowInGroupBy: boolean;
    ShowInSortBy: boolean;
    ShowInColumnList: boolean;
    IsDefaultQueryColumn: boolean;
    LookupObjectTable: ObjectTable | null;
    ObjectFieldSetting: ObjectFieldSetting | null;
    ObjectFieldLabel: ObjectFieldLabel | null;
    ValueFormatCode: string | null;
    Readonly: boolean;
}